import Breadcrumb from './Breadcrumb';
export default Breadcrumb;
//# sourceMappingURL=index.js.map